import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocalizationManager } from '@mosaik/core';
import { LocalizeDirective } from './Localize';

/**
 * @public
 */
@NgModule({
  declarations: [LocalizeDirective],
  exports: [LocalizeDirective]
})
export class LocalizeModule {
  public static forRoot(): ModuleWithProviders<LocalizeModule> {
    return {
      ngModule: LocalizeModule,
      providers: [LocalizationManager]
    };
  }
}
